export default __webpack_public_path__ + "static/media/Sharif-Hussain-Madna.2d97e042.jpg";